export const goBackOneSegment = (location, router) => {
    goBackXSegments(location, router, 1);
};

export const goBackTwoSegments = (location, router) => {
    goBackXSegments(location, router, 2);
};

function goBackXSegments(location, router, amount) {
    const path = location.pathname.split('/');
    for (let i = 0; i < amount; i++) {
        path.pop();
    }
    router.push(path.join('/'));
}
